import API_BASE_URL from '../config';
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { GLOBAL_CALCULATIONS } from './GlobalLogic';
import { toast } from 'react-toastify';

const UpdateOrder = () => {
    const params = useParams();
    const navigate = useNavigate();

    // --- STATES ---
    const [articles, setArticles] = useState([]);
    const [inventory, setInventory] = useState([]);
    const [submitting, setIsSubmitting] = useState(false);
    const [custname, setCustname] = useState("");
    const [phonenumber, setPhonenumber] = useState("");
    const [instagramid, setInstagramid] = useState("");
    const [articlename, setArticlename] = useState("");
    const [sellingprice, setSellingprice] = useState(0);
    const [dateoforder, setDateoforder] = useState("");
    const [dateofdelivery, setDateofdelivery] = useState("");
    
    // --- COST STATES ---
    const [fabricCost, setFabricCost] = useState(0);
    const [workCost, setWorkCost] = useState(0);
    const [stitchingCost, setStitchingCost] = useState(0);
    const [lasesCost, setLasesCost] = useState(0);
    const [dupattaCost, setDupattaCost] = useState(0);
    const [extracost, setExtraCost] = useState(0);

    // --- NEW COST FIELDS ---
    const [fabricdye, setFabricdye] = useState(0);
    const [dupattadye, setDupattadye] = useState(0);
    const [lining, setLining] = useState(0);
    const [fabricdispatch, setFabricdispatch] = useState(0);
    const [fabricsourcing, setFabricsourcing] = useState(0);
    const [unstitcheddispatch, setUnstitcheddispatch] = useState(0);
    const [stitcheddispatch, setStitcheddispatch] = useState(0);
    const [packagingcost, setPackagingcost] = useState(0);
    const [packagedispatched, setPackagedispatched] = useState(0);
    const [courierfee, setCourierfee] = useState(0);

    // --- LOGISTICS & STATUS ---
    const [shippingLegs, setShippingLegs] = useState({
        to_karigar: 0, to_sufna: 0, to_courier: 0, to_customer: 0
    });
    const [odrsts, setOdrSts] = useState("");
    const [odrint, setOdrInt] = useState("");
    const [deldays, setDelDays] = useState("");
    const [odrpart, setOdrpart] = useState("");
    const [odrtrack, setOdrtrack] = useState("");
    const [phase, setPhase] = useState(1);

    // --- PAYMENT ---
    const [payrec, setPayrec] = useState(0); 
    const [paygav, setPaygav] = useState(false); 
    const [paystch, setPaystch] = useState(false); 

    useEffect(() => {
        getOrderDetail();
        getArticles();
        getInventory();
    }, []);

    const getArticles = async () => {
        try {
            let result = await fetch(`${API_BASE_URL}/articleshowa`);
            let data = await result.json();
            if (Array.isArray(data)) setArticles(data);
        } catch (error) { console.error("Error fetching articles:", error); }
    };

    const getInventory = async () => {
        try {
            let result = await fetch(`${API_BASE_URL}/inventoryshowa`); 
            let data = await result.json();
            if (Array.isArray(data)) setInventory(data);
        } catch (error) { console.error("Error inventory:", error); }
    };

    const getOrderDetail = async () => {
        try {
            let result = await fetch(`${API_BASE_URL}/order/${params.id}`);
            let data = await result.json();
            
            setCustname(data.custname || "");
            setPhonenumber(data.phonenumber || "");
            setInstagramid(data.instagramid || "");
            setArticlename(data.articlename || "");
            setSellingprice(data.sellingprice || 0);
            setFabricCost(data.fabric || 0);
            setWorkCost(data.work || 0);
            setStitchingCost(data.stitching || 0);
            setLasesCost(data.lases || 0);
            setDupattaCost(data.dupatta || 0);
            setExtraCost(data.extracost || 0);
            setFabricdye(data.fabricdye || 0);
            setDupattadye(data.dupattadye || 0);
            setLining(data.lining || 0);
            setFabricdispatch(data.fabricdispatch || 0);
            setFabricsourcing(data.fabricsourcing || 0);
            setUnstitcheddispatch(data.unstitcheddispatch || 0);
            setStitcheddispatch(data.stitcheddispatch || 0);
            setPackagingcost(data.packagingcost || 0);
            setPackagedispatched(data.packagedispatched || 0);
            setCourierfee(data.courierfee || 0);
            setPhase(data.phase || 1);
            setPaystch(data.paystch || false);
            setOdrSts(data.odrsts || "Order Confirmed");
            setOdrInt(data.odrint || "");
            setDelDays(data.deldays || "");
            setPayrec(data.payrec || 0);
            setPaygav(data.paygav || false);
            setOdrpart(data.odrpart || ""); 
            setOdrtrack(data.odrtrack || ""); 

            if (data.shipping_details) setShippingLegs(data.shipping_details);
            else setShippingLegs(prev => ({ ...prev, to_customer: data.shipping || 0 }));

            if (data.dateoforder) setDateoforder(new Date(data.dateoforder.$date || data.dateoforder).toISOString().split('T')[0]);
            if (data.dateofdelivery) setDateofdelivery(new Date(data.dateofdelivery.$date || data.dateofdelivery).toISOString().split('T')[0]);
        } catch (error) { console.error("Error fetching order details:", error); }
    };

    const formatProperCase = (name) => {
        if (!name) return "";
        return name.toLowerCase().trim().split(/\s+/).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    };
    const formatInsta = (val) => val ? val.replace('@', '').toLowerCase().trim() : "";
    const formatPhone = (val) => val.replace(/\D/g, '').slice(-10);

    const totalShipping = Object.values(shippingLegs).reduce((acc, curr) => acc + Number(curr), 0);
    
    const productionExpenses = Number(fabricdye) + Number(dupattadye) + Number(lining) + 
                             Number(fabricdispatch) + Number(fabricsourcing) + Number(unstitcheddispatch) + 
                             Number(stitcheddispatch) + Number(packagingcost) + Number(packagedispatched) + Number(courierfee);

    const currentTotalCost = Number(fabricCost) + Number(workCost) + Number(stitchingCost) + 
                            Number(lasesCost) + Number(dupattaCost) + Number(extracost) + productionExpenses;

    const netProfit = Number(sellingprice) - currentTotalCost - totalShipping;
    const customerBalance = Number(sellingprice) - Number(payrec);
    const isCustomerClear = customerBalance <= 0 && Number(sellingprice) > 0;

    const handleUpdate = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const updatedData = {
            custname: formatProperCase(custname),
            phonenumber: formatPhone(phonenumber),
            instagramid: formatInsta(instagramid),
            articlename,
            sellingprice: Number(sellingprice),
            fabric: Number(fabricCost),
            work: Number(workCost),
            stitching: Number(stitchingCost),
            lases: Number(lasesCost),
            dupatta: Number(dupattaCost),
            extracost: Number(extracost),
            fabricdye: Number(fabricdye),
            dupattadye: Number(dupattadye),
            lining: Number(lining),
            fabricdispatch: Number(fabricdispatch),
            fabricsourcing: Number(fabricsourcing),
            unstitcheddispatch: Number(unstitcheddispatch),
            stitcheddispatch: Number(stitcheddispatch),
            packagingcost: Number(packagingcost),
            packagedispatched: Number(packagedispatched),
            courierfee: Number(courierfee),
            phase: Number(phase),
            dateoforder,
            dateofdelivery,
            shipping: totalShipping,
            shipping_details: shippingLegs,
            odrsts,
            odrint,
            odrpart,
            odrtrack,
            deldays: Number(deldays),
            payrec: Number(payrec),
            paygav: Boolean(paygav),
            paystch: Boolean(paystch)
        };

        try {
            let response = await fetch(`${API_BASE_URL}/update-order/${params.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(updatedData)
            });

            if (response.ok) {
                setIsSubmitting(false);
                toast.success("✅ Order Updated Successfully!");
                navigate('/orders');
            }
        } catch (error) {
            setIsSubmitting(false);
            toast.alert("❌ Server Error");
        }
    };

    return (
        <div className="container py-5 bg-light min-vh-100">
            <div className="row justify-content-center">
                <div className="col-lg-11">
                    <div className="d-flex align-items-center mb-4">
                        <button type="button" className="btn btn-white shadow-sm me-3 rounded-circle border" onClick={() => navigate('/orders')}>←</button>
                        <h2 className="mb-0 fw-bold">Update <span className="text-primary">Order</span></h2>
                    </div>

                    <form onSubmit={handleUpdate}>
                        <div className="row g-4">
                            {/* LEFT COLUMN: PRIMARY INPUTS */}
                            <div className="col-md-7">
                                <div className="card shadow-sm border-0 p-4 mb-4">
                                    <h5 className="fw-bold text-secondary mb-3 border-bottom pb-2">👤 Customer Info</h5>
                                    <div className="form-floating mb-3">
                                        <input className="form-control bg-light border-0" value={custname} onChange={(e) => setCustname(e.target.value)} required placeholder="Name" />
                                        <label>Customer Name</label>
                                    </div>
                                    <div className="row g-2">
                                        <div className="col-6"><div className="form-floating"><input className="form-control bg-light border-0" value={phonenumber} onChange={(e) => setPhonenumber(e.target.value)} placeholder="Phone" /><label>Phone</label></div></div>
                                        <div className="col-6"><div className="form-floating"><input className="form-control bg-light border-0" value={instagramid} onChange={(e) => setInstagramid(e.target.value)} placeholder="Insta" /><label>Instagram ID</label></div></div>
                                    </div>
                                </div>

                                <div className="card shadow-sm border-0 p-4 mb-4">
                                    <h5 className="fw-bold text-secondary mb-3 border-bottom pb-2">🧶 Fabric & Dyeing</h5>
                                    <div className="row g-2 mb-3">
                                        <div className="col-4"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={fabricCost} onChange={(e)=>setFabricCost(e.target.value)} /><label>Fabric</label></div></div>
                                        <div className="col-4"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={fabricdye} onChange={(e)=>setFabricdye(e.target.value)} /><label>Fabric Dye</label></div></div>
                                        <div className="col-4"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={lining} onChange={(e)=>setLining(e.target.value)} /><label>Lining</label></div></div>
                                    </div>
                                    <div className="row g-2">
                                        <div className="col-6"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={dupattaCost} onChange={(e)=>setDupattaCost(e.target.value)} /><label>Dupatta</label></div></div>
                                        <div className="col-6"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={dupattadye} onChange={(e)=>setDupattadye(e.target.value)} /><label>Dupatta Dye</label></div></div>
                                    </div>
                                </div>

                                <div className="card shadow-sm border-0 p-4">
                                    <h5 className="fw-bold text-secondary mb-3 border-bottom pb-2">🪡 Work & Stitching</h5>
                                    <div className="row g-2 mb-3">
                                        <div className="col-6"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={workCost} onChange={(e)=>setWorkCost(e.target.value)} /><label>Work (Hand/Machine)</label></div></div>
                                        <div className="col-6"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={stitchingCost} onChange={(e)=>setStitchingCost(e.target.value)} /><label>Stitching</label></div></div>
                                    </div>
                                    <div className="row g-2">
                                        <div className="col-6"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={lasesCost} onChange={(e)=>setLasesCost(e.target.value)} /><label>Lases/Material</label></div></div>
                                        <div className="col-6"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={extracost} onChange={(e)=>setExtraCost(e.target.value)} /><label>Extra Cost</label></div></div>
                                    </div>
                                </div>
                            </div>

                            {/* RIGHT COLUMN: LOGISTICS & STATUS */}
                            <div className="col-md-5">
                                <div className="card shadow-sm border-0 p-4 mb-4 bg-primary-subtle border-primary">
                                    <h5 className="fw-bold text-primary mb-3">💰 Financial Summary</h5>
                                    <div className="form-floating mb-3">
                                        <input className="form-control border-primary fw-bold text-primary" type="number" value={sellingprice} onChange={(e) => setSellingprice(e.target.value)} required />
                                        <label className="text-primary">Selling Price</label>
                                    </div>
                                    <div className="row g-2 text-center">
                                        <div className="col-6"><div className="p-2 border rounded bg-white"><small className="text-muted d-block small fw-bold">Total Cost</small><span className="fw-bold text-dark">₹{currentTotalCost}</span></div></div>
                                        <div className="col-6"><div className={`p-2 border rounded bg-white ${netProfit >= 0 ? 'border-success' : 'border-danger'}`}><small className={`${netProfit >= 0 ? 'text-success' : 'text-danger'} d-block small fw-bold`}>Net Profit</small><span className={`fw-bold ${netProfit >= 0 ? 'text-success' : 'text-danger'}`}>₹{netProfit}</span></div></div>
                                    </div>
                                </div>

                                <div className="card shadow-sm border-0 p-4 mb-4">
                                    <h5 className="fw-bold text-secondary mb-3 border-bottom pb-2">🚚 Production Logistics</h5>
                                    <div className="row g-2 mb-2">
                                        <div className="col-6"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={fabricsourcing} onChange={(e)=>setFabricsourcing(e.target.value)} /><label>Sourcing (On Road)</label></div></div>
                                        <div className="col-6"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={fabricdispatch} onChange={(e)=>setFabricdispatch(e.target.value)} /><label>Fabric Dispatched</label></div></div>
                                    </div>
                                    <div className="row g-2 mb-2">
                                        <div className="col-6"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={unstitcheddispatch} onChange={(e)=>setUnstitcheddispatch(e.target.value)} /><label>Unstitched Disp.</label></div></div>
                                        <div className="col-6"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={stitcheddispatch} onChange={(e)=>setStitcheddispatch(e.target.value)} /><label>Stitched Disp.</label></div></div>
                                    </div>
                                    <div className="row g-2">
                                        <div className="col-6"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={packagingcost} onChange={(e)=>setPackagingcost(e.target.value)} /><label>Packaging Cost</label></div></div>
                                        <div className="col-6"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={packagedispatched} onChange={(e)=>setPackagedispatched(e.target.value)} /><label>Package Disp.</label></div></div>
                                    </div>
                                </div>

                                <div className="card shadow-sm border-0 p-4">
                                    <h5 className="fw-bold text-secondary mb-3 border-bottom pb-2">📦 Courier & Delivery</h5>
                                    <div className="row g-2 mb-3">
                                        <div className="col-8"><div className="form-floating"><input className="form-control bg-light border-0" type="date" value={dateofdelivery} onChange={(e) => { setDateofdelivery(e.target.value); setDelDays(GLOBAL_CALCULATIONS.getDaysFromDate(e.target.value)); }} required /><label>Delivery Date</label></div></div>
                                        <div className="col-4"><div className="form-floating"><input className="form-control border-primary fw-bold" type="number" value={deldays} onChange={(e) => { setDelDays(e.target.value); setDateofdelivery(GLOBAL_CALCULATIONS.getDateFromDays(e.target.value)); }} /><label className="text-primary">Days</label></div></div>
                                    </div>
                                    <div className="row g-2 mb-3">
                                        <div className="col-12"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={courierfee} onChange={(e)=>setCourierfee(e.target.value)} /><label>Courier Fee</label></div></div>
                                    </div>
                                    <div className="row g-2">
                                        <div className="col-5"><div className="form-floating"><select className="form-select bg-light border-0" value={odrpart} onChange={(e) => setOdrpart(e.target.value)}><option value="">None</option>{["Delhivery", "BlueDart", "India Post"].map(p => <option key={p} value={p}>{p}</option>)}</select><label>Partner</label></div></div>
                                        <div className="col-7"><div className="form-floating"><input className="form-control bg-light border-0" placeholder="Tracking ID" value={odrtrack} onChange={(e) => setOdrtrack(e.target.value)} /><label>Tracking ID</label></div></div>
                                    </div>
                                </div>
                            </div>

                            {/* FULL WIDTH: PAYMENT & STATUS */}
                            <div className="col-12">
                                <div className="card shadow-sm border-0 p-4">
                                    <div className="row g-3 align-items-center">
                                        <div className="col-md-3">
                                            <div className="form-floating">
                                                <select className="form-select bg-primary text-white fw-bold" value={odrsts} onChange={(e) => setOdrSts(e.target.value)}>
                                                    <option>Order Confirmed</option><option>Fabric Recieved</option><option>Embroidery</option><option>Stiching</option><option>Ready To Ship</option><option>Delivered</option>
                                                </select>
                                                <label className="text-white">Order Status</label>
                                            </div>
                                        </div>
                                        <div className="col-md-2"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={payrec} onChange={(e) => setPayrec(e.target.value)} max={sellingprice}/><label>Amt Received</label></div></div>
                                        <div className="col-md-2">
                                            <div className="form-check form-switch p-3 border rounded bg-light d-flex align-items-center justify-content-center">
                                                <input className="form-check-input me-2" type="checkbox" checked={paygav} onChange={(e) => setPaygav(e.target.checked)} />
                                                <label className="form-check-label fw-bold text-secondary small">Paid Karigar?</label>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-check form-switch p-3 border rounded bg-light d-flex align-items-center justify-content-center">
                                                <input className="form-check-input me-2" type="checkbox" checked={paystch} onChange={(e) => setPaystch(e.target.checked)} />
                                                <label className="form-check-label fw-bold text-secondary small">Paid Tailor?</label>
                                            </div>
                                        </div>
                                        <div className="col-md-3"><div className={`h-100 d-flex flex-column justify-content-center align-items-center rounded-3 p-3 border ${isCustomerClear ? 'bg-success text-white' : 'bg-white border-warning text-warning'}`}><small className="fw-bold" style={{fontSize: '10px'}}>CUSTOMER BALANCE</small><span className="fw-bold">{isCustomerClear ? "CLEARED" : `₹${customerBalance}`}</span></div></div>
                                    </div>
                                    
                                    <div className="form-floating mt-4 mb-3">
                                        <textarea className="form-control bg-light border-0" style={{height: "80px"}} value={odrint} onChange={(e) => setOdrInt(e.target.value)} placeholder="Instructions"></textarea>
                                        <label>Special Instructions / Notes</label>
                                    </div>

                                    <div className="d-flex justify-content-end gap-2 border-top pt-3">
                                        <button type="button" className="btn btn-outline-secondary px-5 py-2 fw-bold" onClick={() => navigate('/orders')}>Cancel</button>
                                        <button type="submit" className="btn btn-primary px-5 py-2 fw-bold shadow" disabled={submitting}>Update Order</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default UpdateOrder;